import * as ActionType from '../../constants/actionType';
import {NormalizationType, WellIncrementPattern} from '../../constants/dataEnum';

const initialState = {
  currentWizardView: 1,
  csvFileName: '',
  csvRawData: '',
  csvData: [],
  totalRow: 0,
  delimiter: ',', // (delimiter character)
  startRow: 2,
  wellIncrementPattern: WellIncrementPattern.ORDER_BY_ROW, // (orderByRow, orderByColumn)
  selectedColumnIndex: null,
  targetConcentration: 0.0,
  currentVolume: 0,
  previewData: [
    /* {
      row: 0,
      col: 0,
      reagentCurrentConcentration: 0.0,
      volume: 0.0,
      status: '' // (normal, overflow, skipped, unused)
    } */
  ],
  type: NormalizationType.FIXED_SAMPLE_VOLUME,
  diluentWell: {},
  sampleLabwareID: '',
  diluentLabwareID: '',
};

export default function normalizationStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: action.currentWizardView};
    case ActionType.INCREMENT_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: state.currentWizardView + 1};
    case ActionType.DECREMENT_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: state.currentWizardView - 1};
    case ActionType.SET_ALLOWED_TO_NEXT:
      return {...state, allowedToNext: action.allowedToNext};
    case ActionType.SET_CSV_FILE_NAME:
      return {...state, csvFileName: action.csvFileName};
    case ActionType.SET_CSV_RAW_DATA:
      return {...state, csvRawData: action.csvRawData};
    case ActionType.SET_CSV_DATA:
      return {...state, csvData: action.csvData};
    case ActionType.SET_CSV_TOTAL_ROW:
      return {...state, totalRow: action.totalRow};
    case ActionType.SET_CSV_DELIMITER:
      return {...state, delimiter: action.delimiter};
    case ActionType.SET_CSV_START_ROW:
      return {...state, startRow: action.startRow};
    case ActionType.SET_CSV_COLUMN_IN_FIRST_ROW:
      return {...state, isColumnInFirstRow: action.isColumnInFirstRow};
    case ActionType.SET_WELL_INCREMENT_PATTERN:
      return {...state, wellIncrementPattern: action.wellIncrementPattern};
    case ActionType.SET_NORMALIZATION_SELECTED_LABWARE:
      return {...state, sampleLabwareID: action.sampleLabwareID};
    case ActionType.SET_SELECTED_COLUMN_INDEX:
      return {...state, selectedColumnIndex: action.selectedColumnIndex};
    case ActionType.SET_TARGET_CONCENTRATION:
      return {...state, targetConcentration: action.targetConcentration};
    case ActionType.SET_LOWEST_CONCENTRATION:
      return {...state, lowestConcentration: action.lowestConcentration};
    case ActionType.SET_NORMALIZATION_CURRENT_VOLUME:
      return {...state, currentVolume: action.currentVolume};
    case ActionType.SET_REAGENT_NAME:
      return {...state, reagentName: action.reagentName};
    case ActionType.SET_DILUENT_NAME:
      return {...state, diluentName: action.diluentName};
    case ActionType.SET_PREVIEW_DATA:
      return {...state, previewData: action.previewData};
    case ActionType.SET_DILUENT_LABWARE_ID:
      return {...state, selectedDiluentLabwareID: action.selectedDiluentLabwareID};
    case ActionType.SET_DILUENT_WELL:
      return {...state, diluentWell: action.wellParam};
    case ActionType.RESTORE_NORMALIZATION_STATE:
      return action.state;
    case ActionType.RESET_NORMALIZATION_STATE:
      return initialState;
    case ActionType.RESET_NORMALIZATION_CURRENT_VOLUME:
      return {...state, currentVolume: initialState.currentVolume};
    case ActionType.SET_DEFAULT_TARGET_CONCENTRATION:
      return {...state, defaultTargetSetting: {...state.defaultTargetSetting, targetConcentration: action.data}};
    case ActionType.RESET_DEFAULT_CURRENT_VOLUME:
      return {
        ...state,
        defaultTargetSetting: {
          ...state.defaultTargetSetting,
          currentVolume: initialState.defaultTargetSetting.currentVolume,
        },
      };
    case ActionType.SET_NORMALIZATION_TYPE:
      return {...state, type: action.data};
    case ActionType.SET_NORMALIZATION_DILUENT_LABWARE:
      return {...state, diluentLabwareID: action.diluentLabwareID};
    default:
      return state;
  }
}
